import Box from '@mui/material/Box';
import { TooltipForEllipsisElement } from '../TooltipForEllipsisElement';

export interface IHeaderWithEllipsisTooltipProps {
  headerName?: string;
}

function HeaderWithEllipsisTooltip({ headerName }: IHeaderWithEllipsisTooltipProps) {
  return (
    <TooltipForEllipsisElement title={headerName}>
      <Box
        className="MuiDataGrid-columnHeaderTitle"
        sx={{
          fontWeight: 'fontWeightMedium',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {headerName}
      </Box>
    </TooltipForEllipsisElement>
  );
}

export default HeaderWithEllipsisTooltip;
